import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import LabelValue from '../../LabelValue';
import { Driver } from '../../../data/models/driver.model';
import emailUtils from '../../../services/emailUtils';
import phoneUtils from '../../../services/phoneUtils';
import { usePhone } from '../../../hooks/usePhone';
import { useBooleanStatus } from '../../../hooks/useBooleanStatus';
import driverUtils from '../../../services/driverUtils';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';

interface ContactInfoProps {
  driver: Driver | null;
  titleStyle: string;
}

export default function ContactInfo(props: ContactInfoProps) {
  const { t } = useTranslation('common');

  const { driver, titleStyle } = props;

  const email = emailUtils.getDriverEmail(driver?.emailAddresses);

  const primaryPhone = phoneUtils.getDriverPrimaryPhone(driver?.phoneNumbers);
  const hasSMSConsent = useBooleanStatus(primaryPhone?.hasSMSConsent);
  const secondaryPhone = phoneUtils.getDriverSecondaryPhone(
    driver?.phoneNumbers,
  );

  return (
    <>
      <Typography className={titleStyle}>{t('driver.contact')}</Typography>
      <Grid container spacing={2} className={FULLSTORY_MASK_CLASSNAME}>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('common.firstName')}
            value={driver?.driverFirstName}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('driver.middleName')}
            value={driver?.driverMiddleName}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('common.lastName')}
            value={driver?.driverLastName}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue label={t('common.email')} value={email?.emailAddress} />
        </Grid>
        <Grid item sm={12} md={6}>
          {driver && (
            <LabelValue
              label={'Username'}
              value={driverUtils.getDriverUsername(driver)}
            />
          )}
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue label={t('common.hasSMSConsent')} value={hasSMSConsent} />
        </Grid>
        <Grid item sm={12} md={12}>
          <LabelValue
            label={t('driver.primaryPhone')}
            value={usePhone(primaryPhone)}
          />
        </Grid>
      </Grid>
    </>
  );
}
